import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.032 2.456-.193 5.233-.834 7.984H.836c-.67-2.744-.864-5.516-.833-8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.835 24h30.327l-.029.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124L.836 24Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M19.643 18.952c.659-.563.988-1.463.988-2.7v-5.517l-4.526 5.918-4.539-5.918v5.517c0 1.237.33 2.137.987 2.7.659.562 1.838.188 3.538-1.122 1.715 1.31 2.894 1.684 3.552 1.122Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M18.876 17.9c.516-.563.774-1.486.774-2.404V12.05l-3.546 4.537-3.557-4.537v3.413c0 .78.268 1.874.784 2.437.516.562 1.43.616 2.762-.694 1.343 1.31 2.267 1.256 2.783.694Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18.46 17.078c.438-.563.658-1.781.658-2.7v-1.703l-3.015 3.912-3.024-3.912v1.67c0 .78.228 2.17.667 2.733.438.562 1.299 1.232 2.357.413 1.119.894 1.918.15 2.357-.413Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M20.258 21.089c.772-.563 1.159-1.463 1.159-2.7v-5.517l-5.31 5.918-5.326-5.918v5.517c0 1.237.386 2.137 1.158 2.7.611.445 1.604.304 2.98-.423.143-.075-1.097 1.206-.944 1.561.236.548 1.87.06 2.124-.105.198.128 1.736.66 1.92.206.199-.493-.958-1.772-.77-1.673 1.395.736 2.395.88 3.009.434Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M19.358 20.037c.605-.563.908-1.486.908-2.404v-3.446l-4.161 4.537-4.174-4.537V17.6c0 .78.315 1.874.92 2.436.482.448 1.4.605 2.485-.024.207.9-.825 2.18-.58 3.014.105.355 1.118.125 1.267 0 .118.098 1.241.277 1.323 0 .14-.48-.848-3.122-.654-3.014 1.067.593 2.192.465 2.666.024Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18.87 19.215c.514-.563.771-1.782.771-2.7v-1.703l-3.537 3.912-3.548-3.912v1.67c0 .78.268 2.17.782 2.733.397.433 1.088.93 1.952.76.13-.025.425 0 .425 0s-.553 3.454-.352 3.716c.2.262.653-.093.653-.093s.575.3.67.093c.244-.524-.364-3.715-.364-3.715s.554.015.608.027c.886.194 1.54-.352 1.94-.788Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M14.784 19.803h2.63a.707.707 0 0 1 0 1.413h-2.63a.707.707 0 1 1 0-1.413Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M16.12 19.82c1.634 0 2.959-1.811 2.959-4.045 0-2.233-1.325-4.043-2.959-4.043-1.634 0-2.959 1.81-2.959 4.043 0 2.234 1.325 4.044 2.959 4.044Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      d: "M13.424 15.785c0 2.058 1.207 3.725 2.697 3.725s2.697-1.668 2.697-3.725c0-2.057-1.208-3.725-2.697-3.725-1.49 0-2.697 1.668-2.697 3.725Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M18.818 15.77v.015c0 .78-.173 1.502-.47 2.1h-4.455a4.754 4.754 0 0 1-.47-2.1v-.015h5.395Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#557176",
      d: "M13.427 15.966a.43.43 0 0 1 .098-.01c.177 0 .124.018.327.044.204.026.354.026.425.035.07.01.221.027.274.044.053.018.142.062.142.062s-.036.027.115.027c.15 0 .106-.01.318-.01.213 0 .07.054.345 0 .274-.052.487-.079.557-.096.071-.018-.08-.07.186-.036.266.036.39.01.434.01.044 0 .23.008.318.008.089 0 .212 0 .265.009.054.009.133-.009.248.009.115.017.142-.036.23.017.089.053.248.018.31.01.062-.01.186 0 .221 0s.203.017.283.017c.08 0 .239-.018.239-.018l.047.006a5.234 5.234 0 0 0 .003-.543c-.556-.056-.339-.093-.696-.116-.088-.018-.513-.123-.601-.141-.089-.018-.567-.16-.708-.16-.142 0-.496.019-.584.019-.088 0-.858-.018-.964-.018 0 0-.283-.097-.354-.124-.07-.026-.08-.017-.31-.008-.23.008-.283.035-.495.008-.212-.026-.39 0-.487.018a1.237 1.237 0 0 0-.139.037 5.133 5.133 0 0 0-.047.9Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M17.05 17.349c.084-.063.359-.197.442-.197.082 0-.692-.024-1.01-.07-.29-.043-.534-.122-.518-.134a8.25 8.25 0 0 1 .27-.171c-.016.003-.784-.106-.846-.15-.06-.045-.458-.305-.44-.326.03-.035.074-.054.022-.098-.054-.044-.439-.138-.434-.14.019-.006.062-.018.095-.04.041-.03 0-.047-.05-.074-.067-.036-.183-.088-.235-.126-.054-.038.056-.105.166-.154.11-.049.387-.287.428-.324l-.002-.014s-.305.245-.341.27c-.037.024-.182.088-.258.125-.075.038-.077.113-.051.126.025.013.198.12.211.14.013.019-.088.092-.088.092.091.125.445.132.388.172-.056.04-.16.034-.089.104.048.048.167.143.242.181.106.054.35.241.297.264-.053.022-.306.053-.367.08-.06.026-.519-.036-.562-.047.024.007.275.08.48.154.183.066.325.132.296.143-.061.022-.737.124-.855.107-.06-.01.203.015.41.107.197.087.338.24.319.245-.04.009-.441.042-.65.098-.264.07-.432.147-.428.189.011.048.074.144.114.216.494.86 1.258 1.413 2.115 1.413.938 0 1.765-.662 2.248-1.666-.016-.003-1.358-.466-1.318-.495Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M13.564 14.975c.163-.053.434-.19.56-.303.126-.114.409-.273.528-.35.119-.075.275-.212.439-.174.163.038.277.139.342.124.144-.032.206.128.371.134.075.003.245-.015.327.06.082.077.238.176.313.236.074.061.06.023.252.168.194.144.164.197.246.197.081 0 .089-.046.163 0 .075.046.023.091.253.144.23.053.439.129.52.197l.069.016s-.306.02-.589-.016a2.161 2.161 0 0 1-.49-.128c-.013-.007-.13.055-.282.076a2.085 2.085 0 0 1-.537 0c-.162-.039-.323-.145-.526-.145-.296 0-.524.138-.551.145-.06.015-.045-.03-.06-.054a1.144 1.144 0 0 0-.285-.235c-.038-.018-.615.099-.637.06-.022-.037-.463.054-.448 0 .006-.02-.023-.011-.076-.014l.018-.115a1.16 1.16 0 0 0 .08-.023Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M10.015 9.358s2.474-1.134 3.247-1.197c.375-.03.836-.045 1.125.139.164.105.162.343.334.509.115.11.545.353.545.353s.386-.228.546-.243c.15-.014.782.147.782.147l.508-.176.413-.65 1.998.06 2.425 1.058s-2.197.374-2.871.565c-1.16.328-1.494.665-1.965.832-.158.076-.292.447-.46.564-.078-.016-.298-.252-.298-.252s-1.243 1.371-1.865 1.388c-.26.007.816-1.7.553-1.7-2.656-1.397-5.017-1.397-5.017-1.397Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M16.846 11.88c-.015.005-.057-.035-.073-.058-.015-.022-.193-.085-.193-.085s.01.068.031.13c.021.064.01.172.01.172.005-.007-.052.11-.052.114 0 .005-.057-.126-.057-.126-.058 0-.047-.102-.042-.153.005-.052-.01-.137-.01-.137s-.075-.054-.163.011c-.088.066-.12.023-.12.023-.002 0-.07-.017-.053.065 0 0-.053-.081 0-.14a.596.596 0 0 0 .037-.062c.021-.04.131-.034.173-.034.042 0 .068-.023.094-.063a.311.311 0 0 0 .031-.153l-.002-.302.135.014s-.007.345-.002.385c.005.04.01.08.042.114.031.034.084.034.162.074.079.04.131.16.131.16s.018.148 0 .16c-.02.013-.078-.11-.079-.11Zm-.777.003s-.017-.061-.037-.07l-.03.01c-.048.014-.086-.007-.113-.037-.027-.029-.082-.07-.124-.074-.043-.004-.1.056-.16.196s-.098.118-.098.118c.001-.006-.055.13-.055.13-.08-.05-.047-.18-.047-.18s.004-.046.019-.094a.153.153 0 0 1 .055-.075l-.092.016-.08.073s.005-.006-.027-.023c-.026-.014-.053.011-.064.023-.013.028-.036.082-.027.099.007.012-.04-.105-.033-.155.007-.05.073-.083.11-.095a5.14 5.14 0 0 0 .363-.145 1.55 1.55 0 0 0 .13-.281c0-.028-.02-.138-.02-.138l.059-.185.145.213s-.11.289-.13.326c-.02.037.039.06.124.075.086.013.126.108.126.108s.047.108.006.165Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M15.91 10.037c.128 0 .211.125.304.067.124-.078.197-.292.197-.427 0-.121-.026-.348-.141-.462-.11-.11-.305-.108-.452-.108-.156 0-.315.037-.401.158-.079.11-.053.299-.053.412 0 .146.075.37.23.427.094.035.203-.067.316-.067Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      d: "M15.279 9.164c-.233.014-.462-.141-.462-.141-.288-.056-.305-.317-.305-.317-.115-.044-.214-.34-.214-.34-.179.107-.402.001-.402.001s-.288-.119-.645-.037c-.357.081-.415-.05-.415-.05-.125.005-.251.067-.389.106-.086.025-2.002.778-1.979.772.027-.006.468-.286 1.02-.536a11.896 11.896 0 0 1 1.398-.532c.385-.128.7-.067.88-.002.086.032.563-.015.776.01.213.026.235.376.235.376.04.025-.063.358.075.376.138.02.392.22.392.22.086 0 .096-.003.096-.003s.235-.202.585-.176c.351.025.51.102.51.102.142-.06.406-.165.467-.153.14-.012.329-.208.329-.208s-.085-.595.52-.537c.605.058 1.407.136 1.567.161.161.025.737.19.875.256a31.105 31.105 0 0 0 1.255.554c.303.12.529.319.529.319-.19-.08-.379-.156-.529-.22-.121-.054-.683-.317-.81-.376-.468-.218-.56-.082-.56-.082s-.428-.167-.566-.225a.804.804 0 0 0-.383-.075.786.786 0 0 1-.306-.042c-.077-.025-.911-.058-.911-.058l-.061.092s-.207.041-.222-.025c-.016-.067-.123.3-.176.408-.054.108-.298.072-.36.14-.06.066-.192.11-.222.127s-.189.01-.32.035c0 0-.3-.14-.707-.114-.18.012-.565.194-.565.194Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      d: "M14.483 9.882c.002-.04.04-.062.06-.071a.068.068 0 0 0-.032.043s.109.023.182-.03c.06-.044.081-.024.097-.02v-.012l.004.01c0 .029.105.06.206.06.18-.002.269-.093.54-.061.147.017.418-.098.466-.168.048-.07.077-.144.03-.224-.05-.081-.194-.073-.207-.075 0 0-.232.04-.293.053a1.66 1.66 0 0 1-.247.029c-.049 0-.123-.039-.174-.05-.052-.01-.22-.028-.28.035-.061.064-.1.085-.12.106-.019.02-.096.09-.1.12 0 .006 0 .012.002.019-.222.085-.134.236-.134.236Z"
    }
  )
);
var SvgFlagEcu = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagEcu_default = SvgFlagEcu;

export { FlagEcu_default as default };
